import * as Sentry from '@sentry/vue';

export const SCOPE = {
  GEM_METER_SCOPE: 'GemMeter',
} as const;

type SCOPE_KEY = keyof typeof SCOPE;
type SCOPE_NAME = typeof SCOPE[SCOPE_KEY];

function captureError(featureScope: SCOPE_NAME, logLevel: Sentry.SeverityLevel, extraData: object, error: any) {
  if (import.meta.env.VITE_APP_MODE === 'production') {
    Sentry.withScope((scope) => {
      scope.setTag('scope', featureScope);
      scope.setLevel(logLevel);
      scope.setExtra('data', JSON.stringify(extraData));
      Sentry.captureException(error);
    });
  } else {
    // eslint-disable-next-line no-console
    console.log(error);
  }
}

export default captureError;
